//데이터 로딩
import { AjaxLoading } from '../../actions/Interactions/loading.js';
//페이지 url 호출
import { dataUrlArray } from './pageUrl';
//쿠키 호출
import { cookies } from '../assets/lib/cookies';

function fileLoadSet(callUrl) {
	var scriptHtml = "<script id='pageScript' type='text/javascript' charset='utf-8' src='/js/bundle/" + callUrl + ".js'></script>";
	var cssHtml = "<link id='pageCss' rel='stylesheet' type='text/css' href='/css/" + callUrl + ".css'>";
	$('#pageScript, #pageCss').remove();
	$('body').append(scriptHtml);
	$('head').append(cssHtml);
}

export const fileLoadFrame = {
	init:function(param) {
		var userCheck = cookies.getCookies('user_id');
		$('body').attr('id','page');
		if(param != dataUrlArray[0].url && userCheck != null) {
			// for (var i = 0; i <= dataUrlArray.length -1; i++) {
			// 	if(param == dataUrlArray[i].url) {
			// 		//fileLoadSet(dataUrlArray[i].callurl);
			// 		break;
			// 	}else if(param == '/' || param == '/index' || param == '') {
			// 		//데이터 생성 페이지 인덱스 화면으로 활용
			// 		//fileLoadSet(dataUrlArray[2].callurl);
			// 		break;
			// 	}else if(i == dataUrlArray.length-1) {
			// 		break;
			// 	}
			// }
		}else{
			//로그인 화면
			//fileLoadSet(dataUrlArray[0].callurl);
			$('body').attr('id','login');
		}
		setTimeout(function() {
			$('#container').show();
		}, 200);
	}
}



// WEBPACK FOOTER //
// ./js/controller/route/pageFileCall.js